import { createInitialDataState, IDataState } from 'app/store/app/app.models';

export interface MfaConfigOptions {
  authenticatorEnabled: boolean;
  smsEnabled: boolean;
  rememberDeviceEnabled: boolean;
}

export interface IMfaConfigState {
  mfaConfig: IDataState<MfaConfigOptions>;
  saveStatus: {
    loading: boolean;
    httpError: Error | null;
    success: boolean;
  };
}

export const initialMfaConfigState: IMfaConfigState = {
  mfaConfig: createInitialDataState(null),
  saveStatus: {
    loading: false,
    httpError: null,
    success: false,
  },
};
